/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { IStackProps } from "@fluentui/react";

/**
 * Panel stack token
 */
export const panelProps: IStackProps = {
    tokens: {
        childrenGap: "12"
    }
};

export const panelFooterProps: IStackProps = {
    horizontal: true,
    tokens: {
        childrenGap: 8
    }
};
